import React from 'react'

import Link from '@Pure/Link'

import { mergeDeep } from '@root/utility'

export let form =
{
	model: 'CustomQuote'.toLowerCase(),
	name: 'CustomQuote'.toLowerCase(),

	form_title: 'Demande de devis',

	fields:
	{
		title:
		{
			label: 'Titre'
		},

		admin_email:
		{
			label: 'E-mail destinataire de la demande',
			type: 'email'
		}
	},

	create_label: 'Créer cette demande de devis',

	get__deleteModalText: function (form_data)
	{
		var output =
		(
			<span>
				<p>
					Êtes vous sûr de vouloir supprimer cette demande de devis&nbsp;?
				</p>
			</span>
		);

		return output;
	},

	get__createdMessage: function (model)
	{
		var output =
		(
			<div className="c-message c-message--green">
				<div className="c-message__content">
					Merci pour votre demande de devis, celle-ci a bien été prise en compte.
				</div>
			</div>
		);

		return output;
	}
}

export let list =
{
	model         : 'CustomQuote'.toLowerCase(),
	title         : 'Demandes de devis',
	link          : '/gestion-du-catalogue/demandes-de-devis',
	creation_link : '/gestion-du-catalogue/nouvelle-demande-de-devis',
	creation_label: 'Nouvelle demande de devis',
	header_map    :
	{
		'Titre'           : 'title',
		'Date de création': 'createdAt'
	},

	row_link_base : '/gestion-du-catalogue/demandes-de-devis/',
	searched_prop : 'title',

	field_hook:
	{
		'Date de création': function (value)
		{
			return window.moment(value).format('D MMMM YYYY');
		}
	},
}

let config = mergeDeep({ }, form);

config = mergeDeep(config, list);

export default config;